// extracted by mini-css-extract-plugin
module.exports = {"dot":"StepsBar_dot__2WraD","steps":"StepsBar_steps__3Yrr8"};